import { useAuth } from "../context";

const Login = () => {
  const auth = useAuth();

  const login = () => {
    auth.login('login');
  };
  return (
    <div className="container">
      <div className="headline">Click to login to SSO</div>
      <button onClick={() => login()}>Login</button>
    </div>
  );
};

export default Login;
